module.exports = __webpack_public_path__ + "media/tulum/turtle-fd299087.jpg";